(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4999],{

/***/ 99372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ d; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
var c=function(){return c=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var o in t=arguments[n])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e},c.apply(this,arguments)};var s=function(e){return"object"==typeof e},f=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];return e.filter((function(e){return!s(e)&&!1!==e})).join(" ")},p=function(r){var o=r.placeholder,l=r.separator,p=r.isLastChild,d=r.inputStyle,y=r.focus,v=r.isDisabled,h=r.hasErrored,g=r.errorStyle,m=r.focusStyle,b=r.disabledStyle,S=r.shouldAutoFocus,D=r.isInputNum,k=r.index,I=r.value,O=r.className,x=r.isInputSecure,C=function(e,t){var n={};for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&t.indexOf(r)<0&&(n[r]=e[r]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var o=0;for(r=Object.getOwnPropertySymbols(e);o<r.length;o++)t.indexOf(r[o])<0&&Object.prototype.propertyIsEnumerable.call(e,r[o])&&(n[r[o]]=e[r[o]])}return n}(r,["placeholder","separator","isLastChild","inputStyle","focus","isDisabled","hasErrored","errorStyle","focusStyle","disabledStyle","shouldAutoFocus","isInputNum","index","value","className","isInputSecure"]),N=(0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);(0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)((function(){var e=N.current;e&&y&&S&&e.focus()}),[]),(0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)((function(){var e=N.current;y&&e&&(e.focus(),e.select())}),[y]);var j=(0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)((function(){return x?"password":D?"tel":"text"}),[x,D]);return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div",c({className:O,style:{display:"flex",alignItems:"center"}},{children:[(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input",c({"aria-label":"".concat(0===k?"Please enter verification code. ":"").concat(D?"Digit":"Character"," ").concat(k+1),autoComplete:"off",style:Object.assign({width:"1em",textAlign:"center"},s(d)&&d,y&&s(m)&&m,v&&s(b)&&b,h&&s(g)&&g),placeholder:o,className:f(d,y&&m,v&&b,h&&g),type:j,ref:N,disabled:v,value:I||""},C)),!p&&(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment,{children:l})]}))},d=(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((function(t,n){var r=t.numInputs,i=void 0===r?4:r,u=t.onChange,f=void 0===u?function(e){return console.log(e)}:u,d=t.isDisabled,y=void 0!==d&&d,v=t.shouldAutoFocus,h=void 0!==v&&v,g=t.value,m=void 0===g?"":g,b=t.isInputSecure,S=void 0!==b&&b,D=t.placeholder,k=t.isInputNum,I=t.containerStyle,O=t.inputStyle,x=t.focusStyle,C=t.separator,N=t.disabledStyle,j=t.hasErrored,w=t.errorStyle,A=t.className,E=t["data-cy"],P=t["data-testid"],F=(0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0),L=F[0],B=F[1],M=(0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)((function(){return m?m.toString().split(""):[]}),[m]),q=(0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)((function(){if("string"==typeof D){if(D.length===i)return D;if(D.length>0)return console.error("Length of the placeholder should be equal to the number of inputs."),""}return""}),[i,D]);(0,react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle)(n,(function(){return{focusInput:T}}));var K=function(e){var t=e.join("");f(t)},R=function(e){return(k?!isNaN(parseInt(e,10)):"string"==typeof e)&&1===e.trim().length},T=function(e){var t=Math.max(Math.min(i-1,e),0);B(t)},z=function(){T(L+1)},G=function(){T(L-1)},H=function(e){M[L]=e[0],K(M)},J=function(e){if(e.preventDefault(),!y){for(var t=L,n=e.clipboardData.getData("text/plain").slice(0,i-L).split(""),r=0;r<i;++r)r>=L&&n.length>0&&(M[r]=n.shift(),t++);B(t),T(t),K(M)}},Q=function(e){8===e.keyCode||"Backspace"===e.key?(e.preventDefault(),H(""),G()):46===e.keyCode||"Delete"===e.key?(e.preventDefault(),H("")):37===e.keyCode||"ArrowLeft"===e.key?(e.preventDefault(),G()):39===e.keyCode||"ArrowRight"===e.key?(e.preventDefault(),z()):32!==e.keyCode&&" "!==e.key&&"Spacebar"!==e.key&&"Space"!==e.key||e.preventDefault()},U=function(e){if(R(e.target.value))z();else if(!k){var t=e.nativeEvent;null===t.data&&"deleteContentBackward"===t.inputType&&(e.preventDefault(),H(""),G())}},V=function(e){return function(t){B(e),t.target.select()}},W=function(){return B(-1)};return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div",c({style:Object.assign({display:"flex"},s(I)&&I),className:s(I)?"":I},{children:new Array(i).fill(null).map((function(t,n){var r,o;return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(p,{placeholder:null!==(r=q[n])&&void 0!==r?r:"",index:n,focus:L===n,value:M[n],onChange:(o=n,function(e){var t=e.target.value;0!==o||t.length!==i?R(t)&&H(t):K(t.split(""))}),onKeyDown:Q,onInput:U,onPaste:J,onFocus:V(n),onBlur:W,separator:C,inputStyle:O,focusStyle:x,isLastChild:n===i-1,isDisabled:y,disabledStyle:N,hasErrored:j,errorStyle:w,shouldAutoFocus:h,isInputNum:k,isInputSecure:S,className:A,"data-cy":E&&"".concat(E,"-").concat(n),"data-testid":P&&"".concat(P,"-").concat(n)},n)}))}))}));
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 77824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _vahak_core_dist_standard_icons_location_pin_outlined_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90831);
/* harmony import */ var _vahak_core_dist_standard_icons_location_arrow_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38188);
/* harmony import */ var _vahak_core_dist_services_city_search_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20803);
/* harmony import */ var _fields_QuoteFormLocationField__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68416);
/* harmony import */ var _QuoteFormFields_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62095);
/* harmony import */ var _QuoteFormFields_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_QuoteFormFields_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _loadQuoteForm_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26107);
/* harmony import */ var _compact_load_posting_steps_RouteDetailsStep_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30069);
/* harmony import */ var _compact_load_posting_steps_RouteDetailsStep_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_compact_load_posting_steps_RouteDetailsStep_module_scss__WEBPACK_IMPORTED_MODULE_9__);










// Stable element identities so the memoized react-select `components` in
// QuoteFormLocationField never change across parent re-renders (prevents focus loss).
var PICKUP_ICON = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_standard_icons_location_pin_outlined_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    className: (_QuoteFormFields_module_scss__WEBPACK_IMPORTED_MODULE_8___default().fieldIconPin),
    "aria-hidden": true
});
var DROP_ICON = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_standard_icons_location_arrow_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    className: (_QuoteFormFields_module_scss__WEBPACK_IMPORTED_MODULE_8___default().fieldIcon),
    "aria-hidden": true
});
var LoadQuoteFormFields = function(param) {
    var variant = param.variant, values = param.values, labels = param.labels, locationMessages = param.locationMessages, onChange = param.onChange, onPickupInputChange = param.onPickupInputChange, onDropInputChange = param.onDropInputChange;
    var fieldIds = variant === "routeStep" ? _loadQuoteForm_constants__WEBPACK_IMPORTED_MODULE_7__/* .ROUTE_LOAD_QUOTE_FIELD_IDS */ .MB : _loadQuoteForm_constants__WEBPACK_IMPORTED_MODULE_7__/* .HERO_LOAD_QUOTE_FIELD_IDS */ .wH;
    var isRouteStep = variant === "routeStep";
    var dropFieldRef = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    var pickupField = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fields_QuoteFormLocationField__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        id: fieldIds["quote-pickup-city"],
        name: "pickupCity",
        placeholder: labels.pickupPlaceholder,
        icon: PICKUP_ICON,
        value: values.source,
        onChange: function(source) {
            onChange({
                source: source
            });
            if (source && !isRouteStep) {
                requestAnimationFrame(function() {
                    var ref;
                    return (ref = dropFieldRef.current) === null || ref === void 0 ? void 0 : ref.focus();
                });
            }
        },
        onInputValueChange: onPickupInputChange,
        locationSearchSource: _vahak_core_dist_services_city_search_service__WEBPACK_IMPORTED_MODULE_5__/* .LocationSearchSource.HomepageV2LoadSourcePosting */ .T5.HomepageV2LoadSourcePosting,
        inSheet: isRouteStep,
        fieldRole: "pickup",
        messages: locationMessages
    });
    var dropField = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fields_QuoteFormLocationField__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        id: fieldIds["quote-drop-city"],
        name: "dropCity",
        placeholder: labels.dropPlaceholder,
        icon: DROP_ICON,
        value: values.destination,
        onChange: function(destination) {
            return onChange({
                destination: destination
            });
        },
        selectRef: dropFieldRef,
        onInputValueChange: onDropInputChange,
        locationSearchSource: _vahak_core_dist_services_city_search_service__WEBPACK_IMPORTED_MODULE_5__/* .LocationSearchSource.HomepageV2LoadDestinationPosting */ .T5.HomepageV2LoadDestinationPosting,
        inSheet: isRouteStep,
        fieldRole: "drop",
        messages: locationMessages
    });
    if (isRouteStep) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_QuoteFormFields_module_scss__WEBPACK_IMPORTED_MODULE_8___default().root),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_compact_load_posting_steps_RouteDetailsStep_module_scss__WEBPACK_IMPORTED_MODULE_9___default().formFields),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_compact_load_posting_steps_RouteDetailsStep_module_scss__WEBPACK_IMPORTED_MODULE_9___default().fieldGroup), (_compact_load_posting_steps_RouteDetailsStep_module_scss__WEBPACK_IMPORTED_MODULE_9___default().fieldGroupPickup)),
                        children: [
                            labels.pickupLabel ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                className: (_compact_load_posting_steps_RouteDetailsStep_module_scss__WEBPACK_IMPORTED_MODULE_9___default().label),
                                htmlFor: "".concat(fieldIds["quote-pickup-city"], "__input"),
                                children: labels.pickupLabel
                            }) : null,
                            pickupField
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_compact_load_posting_steps_RouteDetailsStep_module_scss__WEBPACK_IMPORTED_MODULE_9___default().fieldGroup), (_compact_load_posting_steps_RouteDetailsStep_module_scss__WEBPACK_IMPORTED_MODULE_9___default().fieldGroupDrop)),
                        children: [
                            labels.dropLabel ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                className: (_compact_load_posting_steps_RouteDetailsStep_module_scss__WEBPACK_IMPORTED_MODULE_9___default().label),
                                htmlFor: "".concat(fieldIds["quote-drop-city"], "__input"),
                                children: labels.dropLabel
                            }) : null,
                            dropField
                        ]
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_QuoteFormFields_module_scss__WEBPACK_IMPORTED_MODULE_8___default().root),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_QuoteFormFields_module_scss__WEBPACK_IMPORTED_MODULE_8___default().heroRoute),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_QuoteFormFields_module_scss__WEBPACK_IMPORTED_MODULE_8___default().heroRail),
                    "aria-hidden": true,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_QuoteFormFields_module_scss__WEBPACK_IMPORTED_MODULE_8___default().heroRailDot)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_QuoteFormFields_module_scss__WEBPACK_IMPORTED_MODULE_8___default().heroRailLine)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_QuoteFormFields_module_scss__WEBPACK_IMPORTED_MODULE_8___default().heroRailSquare)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_QuoteFormFields_module_scss__WEBPACK_IMPORTED_MODULE_8___default().heroFields),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_QuoteFormFields_module_scss__WEBPACK_IMPORTED_MODULE_8___default().heroField),
                            children: [
                                labels.pickupLabel ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                    className: (_QuoteFormFields_module_scss__WEBPACK_IMPORTED_MODULE_8___default().heroLabel),
                                    htmlFor: "".concat(fieldIds["quote-pickup-city"], "__input"),
                                    children: labels.pickupLabel
                                }) : null,
                                pickupField
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_QuoteFormFields_module_scss__WEBPACK_IMPORTED_MODULE_8___default().heroField),
                            children: [
                                labels.dropLabel ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                    className: (_QuoteFormFields_module_scss__WEBPACK_IMPORTED_MODULE_8___default().heroLabel),
                                    htmlFor: "".concat(fieldIds["quote-drop-city"], "__input"),
                                    children: labels.dropLabel
                                }) : null,
                                dropField
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadQuoteFormFields);


/***/ }),

/***/ 27763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Om": function() { return /* binding */ getQuoteFormLcvSliderCapacityRange; },
/* harmony export */   "f0": function() { return /* binding */ getQuoteFormLcvSliderDefaultTonnes; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94204);
/* harmony import */ var _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14345);
/* harmony import */ var _methods_getLorryCapacityUnitLabel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34363);
/* harmony import */ var _hooks_useHomepageV2Translation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14394);
/* harmony import */ var _load_quote__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20380);
/* harmony import */ var _loadQuoteForm_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26107);











function getLcvSliderCapacityBounds() {
    var configuredBounds = _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_4__/* .NEW_LORRY_CAPACITY.LOAD_POST */ .QZ.LOAD_POST;
    if (configuredBounds.max > 0) {
        return configuredBounds;
    }
    var lorries = (0,_vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_4__/* .getAllowedVehicleList */ .UE)("load");
    if (!lorries.length) {
        return configuredBounds;
    }
    return lorries.reduce(function(range, lorry) {
        return {
            min: Math.min(range.min, lorry.capacity.min),
            max: Math.max(range.max, lorry.capacity.max)
        };
    }, {
        min: Infinity,
        max: -Infinity
    });
}
/** Load-post capacity bounds for the hero LCV slider (`NEW_LORRY_CAPACITY.LOAD_POST`). */ function getQuoteFormLcvSliderCapacityRange() {
    var ref = getLcvSliderCapacityBounds(), min = ref.min, max = ref.max;
    var unit = (0,_methods_getLorryCapacityUnitLabel__WEBPACK_IMPORTED_MODULE_5__/* .getLorryCapacityUnitLabel */ .z)();
    return {
        min: min,
        max: max,
        capacityText: "".concat(min, "-").concat(max, " ").concat(unit),
        unit: unit
    };
}
function getQuoteFormLcvSliderDefaultTonnes() {
    return String(getQuoteFormLcvSliderCapacityRange().min);
}
function getStepDecimalPlaces(step) {
    var ref;
    var stepText = String(step);
    if (!stepText.includes(".")) {
        return 0;
    }
    var ref1;
    return (ref1 = (ref = stepText.split(".")[1]) === null || ref === void 0 ? void 0 : ref.length) !== null && ref1 !== void 0 ? ref1 : 0;
}
function getSliderStep(min, max) {
    var range = max - min;
    for(var _i = 0, _iter = [
        0.1,
        0.25,
        0.5,
        1
    ]; _i < _iter.length; _i++){
        var step = _iter[_i];
        var stepCount = range / step;
        if (Math.abs(stepCount - Math.round(stepCount)) < 1e-6) {
            return step;
        }
    }
    return 0.1;
}
function getSliderFillPercent(value, min, max) {
    if (max <= min) {
        return 0;
    }
    if (value >= max) {
        return 100;
    }
    return (value - min) / (max - min) * 100;
}
function snapSliderValue(value, min, max, step) {
    if (value >= max - step / 2) {
        return max;
    }
    var clamped = Math.max(min, Math.min(value, max));
    var snapped = min + Math.round((clamped - min) / step) * step;
    var decimals = getStepDecimalPlaces(step);
    var normalized = Number(Math.min(max, Math.max(min, snapped)).toFixed(decimals));
    return Math.abs(normalized - max) < step / 2 ? max : normalized;
}
function formatCapacityAmount(value, step) {
    var decimals = getStepDecimalPlaces(step);
    if (decimals === 0) {
        return String(Math.round(value));
    }
    return value.toFixed(decimals);
}
var QuoteFormLcvCapacitySlider = function(param) {
    var id = param.id, value = param.value, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, error = param.error, onChange = param.onChange;
    var ref;
    var t = useHomepageV2Translation().t;
    var ref1 = getQuoteFormLcvSliderCapacityRange(), min = ref1.min, max = ref1.max;
    var ref2;
    var unitShort = (ref2 = (ref = getLorryDetailsByType(QUOTE_FORM_LCV_LORRY_TYPE)) === null || ref === void 0 ? void 0 : ref.unitShort) !== null && ref2 !== void 0 ? ref2 : "T";
    var step = getSliderStep(min, max);
    var parsedValue = parseLoadQuoteCapacity(value);
    var sliderValue = snapSliderValue(parsedValue !== null && parsedValue !== void 0 ? parsedValue : min, min, max, step);
    var sliderProgress = getSliderFillPercent(sliderValue, min, max);
    var capacityUnit = sliderValue === 1 ? t("mktCardV2:tonne") : t("mktCardV2:tonnes");
    var displayValue = useMemo(function() {
        return t("homepageV2:hero.quoteForm.lcvCapacityValue", {
            value: formatCapacityAmount(sliderValue, step),
            unit: capacityUnit
        });
    }, [
        capacityUnit,
        sliderValue,
        step,
        t
    ]);
    var minBoundLabel = formatCapacityAmount(min, step);
    var maxBoundLabel = formatCapacityAmount(max, step);
    var handleSliderChange = function(event) {
        var nextValue = snapSliderValue(Number(event.target.value), min, max, step);
        onChange(String(nextValue));
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: classnames(Styles.section, disabled && Styles.sectionDisabled),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: Styles.valueRow,
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: Styles.valueLabel,
                        children: t("homepageV2:hero.quoteForm.lcvCapacity")
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: Styles.value,
                        children: displayValue
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: Styles.sliderBlock,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: Styles.sliderWrap,
                        children: /*#__PURE__*/ _jsx("input", {
                            id: id,
                            type: "range",
                            className: Styles.slider,
                            style: _define_property({}, "--slider-progress", "".concat(sliderProgress, "%")),
                            min: min,
                            max: max,
                            step: step,
                            value: sliderValue,
                            disabled: disabled || max <= min,
                            "data-at-max": sliderValue >= max ? "true" : "false",
                            onChange: handleSliderChange,
                            onInput: handleSliderChange,
                            "aria-label": t("homepageV2:hero.quoteForm.lcvCapacity"),
                            "aria-valuemin": min,
                            "aria-valuemax": max,
                            "aria-valuenow": sliderValue
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: Styles.sliderBounds,
                        "aria-hidden": true,
                        children: [
                            /*#__PURE__*/ _jsxs("span", {
                                children: [
                                    minBoundLabel,
                                    /*#__PURE__*/ _jsx("span", {
                                        className: Styles.boundUnit,
                                        children: unitShort
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("span", {
                                children: [
                                    maxBoundLabel,
                                    /*#__PURE__*/ _jsx("span", {
                                        className: Styles.boundUnit,
                                        children: unitShort
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            error ? /*#__PURE__*/ _jsx("span", {
                className: Styles.fieldError,
                children: error
            }) : null
        ]
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (QuoteFormLcvCapacitySlider)));


/***/ }),

/***/ 4121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ getQuoteFormCapacityError; }
/* harmony export */ });
/* harmony import */ var _load_quote__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20380);
/* harmony import */ var _fields_QuoteFormLcvCapacitySlider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27763);


function getQuoteFormCapacityError(tonnes, isRemoteConfigLoaded, t) {
    var ref;
    var trimmed = (ref = tonnes === null || tonnes === void 0 ? void 0 : tonnes.trim()) !== null && ref !== void 0 ? ref : "";
    if (!trimmed) {
        return t("homepageV2:hero.quoteForm.capacityRequired");
    }
    var capacity = (0,_load_quote__WEBPACK_IMPORTED_MODULE_0__/* .parseLoadQuoteCapacity */ .lX)(trimmed);
    if (capacity == null) {
        return t("homepageV2:hero.quoteForm.capacityInvalid");
    }
    if (!isRemoteConfigLoaded) {
        return undefined;
    }
    var ref1 = (0,_fields_QuoteFormLcvCapacitySlider__WEBPACK_IMPORTED_MODULE_1__/* .getQuoteFormLcvSliderCapacityRange */ .Om)(), min = ref1.min, max = ref1.max, capacityText = ref1.capacityText;
    if (capacity < min || capacity > max) {
        return t("homepageV2:hero.quoteForm.capacityOutOfRange", {
            range: capacityText
        });
    }
    return undefined;
}


/***/ }),

/***/ 26107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MB": function() { return /* binding */ ROUTE_LOAD_QUOTE_FIELD_IDS; },
/* harmony export */   "MC": function() { return /* binding */ ROUTE_QUOTE_SKIP_CAPACITY_VALIDATION; },
/* harmony export */   "no": function() { return /* binding */ QUOTE_FORM_LCV_LORRY_TYPE; },
/* harmony export */   "wH": function() { return /* binding */ HERO_LOAD_QUOTE_FIELD_IDS; }
/* harmony export */ });
/* harmony import */ var _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14345);

var QUOTE_FORM_LCV_LORRY_TYPE = _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .LORRY_CATEGORIES_ENUM.LCV */ .Sv.LCV;
var HERO_LOAD_QUOTE_FIELD_IDS = {
    "quote-pickup-city": "quote-pickup-city",
    "quote-drop-city": "quote-drop-city",
    "quote-tonnes": "quote-tonnes"
};
var ROUTE_LOAD_QUOTE_FIELD_IDS = {
    "quote-pickup-city": "compact-route-pickup-city",
    "quote-drop-city": "compact-route-drop-city",
    "quote-tonnes": "compact-load-details-tonnes"
};
/** Compact route step validates pickup + drop only; capacity is collected on load details. */ var ROUTE_QUOTE_SKIP_CAPACITY_VALIDATION = {
    skipCapacityValidation: true
};


/***/ }),

/***/ 46473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* binding */ useLoadQuoteLocationForm; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/homepage-v2/analytics/trackLoadQuoteFormAnalytics.ts
var trackLoadQuoteFormAnalytics = __webpack_require__(78582);
// EXTERNAL MODULE: ./components/homepage-v2/analytics/homepageV2WebAnalytics.ts
var homepageV2WebAnalytics = __webpack_require__(7339);
// EXTERNAL MODULE: ./components/homepage-v2/hooks/useCompactSheetAutoFocus.ts
var useCompactSheetAutoFocus = __webpack_require__(77311);
// EXTERNAL MODULE: ./components/homepage-v2/methods/homepageV2CompactSheet.ts
var homepageV2CompactSheet = __webpack_require__(14199);
// EXTERNAL MODULE: ./components/homepage-v2/hero-section/quote-form-card/fields/QuoteFormLcvCapacitySlider.tsx
var QuoteFormLcvCapacitySlider = __webpack_require__(27763);
// EXTERNAL MODULE: ./components/homepage-v2/hero-section/quote-form-card/validateQuoteForm.ts
var validateQuoteForm = __webpack_require__(81090);
// EXTERNAL MODULE: ./components/homepage-v2/hero-section/quote-form-card/loadQuoteForm.constants.ts
var loadQuoteForm_constants = __webpack_require__(26107);
;// CONCATENATED MODULE: ./components/homepage-v2/hero-section/quote-form-card/useLoadQuoteForm.ts




function useLoadQuoteForm(param) {
    var values = param.values, onChange = param.onChange, isRemoteConfigLoaded = param.isRemoteConfigLoaded, t = param.t, _skipCapacityValidation = param.skipCapacityValidation, skipCapacityValidation = _skipCapacityValidation === void 0 ? false : _skipCapacityValidation;
    var validationOptions = (0,react.useMemo)(function() {
        return {
            isRemoteConfigLoaded: isRemoteConfigLoaded,
            t: t,
            skipCapacityValidation: skipCapacityValidation
        };
    }, [
        isRemoteConfigLoaded,
        skipCapacityValidation,
        t
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (!isRemoteConfigLoaded || skipCapacityValidation) {
            return;
        }
        var patch = {};
        if (values.lorryType !== loadQuoteForm_constants/* QUOTE_FORM_LCV_LORRY_TYPE */.no) {
            patch.lorryType = loadQuoteForm_constants/* QUOTE_FORM_LCV_LORRY_TYPE */.no;
        }
        if (!((ref = values.tonnes) === null || ref === void 0 ? void 0 : ref.trim())) {
            patch.tonnes = (0,QuoteFormLcvCapacitySlider/* getQuoteFormLcvSliderDefaultTonnes */.f0)();
        }
        if (Object.keys(patch).length) {
            onChange(patch);
        }
    }, [
        isRemoteConfigLoaded,
        onChange,
        skipCapacityValidation,
        values.lorryType,
        values.tonnes
    ]);
    var isFormValid = (0,react.useMemo)(function() {
        return (0,validateQuoteForm/* isQuoteFormValid */.N$)(values, validationOptions);
    }, [
        validationOptions,
        values
    ]);
    return {
        isFormValid: isFormValid
    };
}

// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
;// CONCATENATED MODULE: ./hooks/useAppUserPlaceInfo.ts


/** Read resolved user location from app context — avoids duplicate location API calls. */ function useAppUserPlaceInfo() {
    var globalData = (0,react.useContext)(app_context/* AppContext */.Il).globalData;
    return globalData === null || globalData === void 0 ? void 0 : globalData.userPlaceInfo;
}
function useAppUserCityLocation() {
    var userPlaceInfo = useAppUserPlaceInfo();
    return useMemo(function() {
        if (!(userPlaceInfo === null || userPlaceInfo === void 0 ? void 0 : userPlaceInfo.place_id)) {
            return undefined;
        }
        var _description;
        return {
            place_id: userPlaceInfo.place_id,
            city: userPlaceInfo.city,
            name: (_description = userPlaceInfo.description) !== null && _description !== void 0 ? _description : userPlaceInfo.city,
            state: userPlaceInfo.state
        };
    }, [
        userPlaceInfo
    ]);
}

;// CONCATENATED MODULE: ./components/homepage-v2/hero-section/quote-form-card/useLoadQuoteLocationForm.ts










function useLoadQuoteLocationForm(param) {
    var values = param.values, onChange = param.onChange, sourceScreen = param.sourceScreen, isRemoteConfigLoaded = param.isRemoteConfigLoaded, t = param.t, trackEvent = param.trackEvent, eventData = param.eventData, _prefillFromContext = param.prefillFromContext, prefillFromContext = _prefillFromContext === void 0 ? false : _prefillFromContext, _autoFocusOnMount = param.autoFocusOnMount, autoFocusOnMount = _autoFocusOnMount === void 0 ? false : _autoFocusOnMount, _focusDropOnPickupSelect = param.focusDropOnPickupSelect, focusDropOnPickupSelect = _focusDropOnPickupSelect === void 0 ? false : _focusDropOnPickupSelect, validationOptionsOverride = param.validationOptions, fieldIdMap = param.fieldIdMap, _variant = param.variant, variant = _variant === void 0 ? "hero" : _variant;
    var ref, ref1, ref2;
    var userPlaceInfo = useAppUserPlaceInfo();
    var didPrefillSourceRef = (0,react.useRef)(false);
    var prevPickupRef = (0,react.useRef)((ref = values.source) === null || ref === void 0 ? void 0 : ref.place_id);
    var skipProgrammaticDropFocusRef = (0,react.useRef)(false);
    var valuesRef = (0,react.useRef)(values);
    valuesRef.current = values;
    var eventDataWithScreen = (0,react.useMemo)(function() {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, eventData), {
            source_screen: sourceScreen
        });
    }, [
        eventData,
        sourceScreen
    ]);
    var trackFieldOnce = (0,homepageV2WebAnalytics/* useTrackWebV2FieldOnce */.YO)(trackEvent, eventDataWithScreen).trackFieldOnce;
    var validationOptions = (0,react.useMemo)(function() {
        return validationOptionsOverride !== null && validationOptionsOverride !== void 0 ? validationOptionsOverride : variant === "routeStep" ? (0,validateQuoteForm/* getRouteQuoteFormValidationOptions */.WC)(isRemoteConfigLoaded, t) : {
            isRemoteConfigLoaded: isRemoteConfigLoaded,
            t: t
        };
    }, [
        isRemoteConfigLoaded,
        t,
        validationOptionsOverride,
        variant
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (!prefillFromContext || didPrefillSourceRef.current || !(userPlaceInfo === null || userPlaceInfo === void 0 ? void 0 : userPlaceInfo.place_id) || ((ref = values.source) === null || ref === void 0 ? void 0 : ref.place_id)) {
            return;
        }
        didPrefillSourceRef.current = true;
        skipProgrammaticDropFocusRef.current = true;
        onChange({
            source: userPlaceInfo
        });
    }, [
        onChange,
        prefillFromContext,
        userPlaceInfo,
        (ref1 = values.source) === null || ref1 === void 0 ? void 0 : ref1.place_id
    ]);
    var handleChange = (0,react.useCallback)(function(patch) {
        (0,trackLoadQuoteFormAnalytics/* trackLoadQuoteFormChange */.GR)(trackFieldOnce, patch, {
            sourceScreen: sourceScreen,
            isRemoteConfigLoaded: isRemoteConfigLoaded,
            previousValues: valuesRef.current
        });
        onChange(patch);
    }, [
        isRemoteConfigLoaded,
        onChange,
        sourceScreen,
        trackFieldOnce
    ]);
    var isFormValid = useLoadQuoteForm({
        values: values,
        onChange: handleChange,
        isRemoteConfigLoaded: isRemoteConfigLoaded,
        t: t,
        skipCapacityValidation: validationOptions.skipCapacityValidation
    }).isFormValid;
    var locationMessages = (0,react.useMemo)(function() {
        return {
            enterLocation: t("homepageV2:hero.quoteForm.enterLocation"),
            noSuchLocation: t("homepageV2:hero.quoteForm.noSuchLocation"),
            getMoreCharactersLabel: function(count) {
                return t("homepageV2:hero.quoteForm.moreCharacters", {
                    count: count
                });
            }
        };
    }, [
        t
    ]);
    var handleLocationInput = (0,react.useCallback)(function(field, inputValue) {
        (0,trackLoadQuoteFormAnalytics/* trackLoadQuoteLocationInput */.LF)(trackFieldOnce, field, inputValue, sourceScreen);
    }, [
        sourceScreen,
        trackFieldOnce
    ]);
    var focusField = (0,react.useCallback)(function(fieldId, options) {
        (0,validateQuoteForm/* focusQuoteFormField */.Kb)(fieldId, {
            fieldIdMap: fieldIdMap,
            delay: options === null || options === void 0 ? void 0 : options.delay,
            scrollIntoView: Boolean(fieldIdMap)
        });
    }, [
        fieldIdMap
    ]);
    var autoFocusFieldId = (0,react.useMemo)(function() {
        if (!autoFocusOnMount) {
            return undefined;
        }
        var firstInvalidField = (0,validateQuoteForm/* getFirstQuoteFormInvalidFieldId */.KG)(values, validationOptions);
        var fieldId = firstInvalidField !== null && firstInvalidField !== void 0 ? firstInvalidField : "quote-pickup-city";
        var ref;
        return (ref = fieldIdMap === null || fieldIdMap === void 0 ? void 0 : fieldIdMap[fieldId]) !== null && ref !== void 0 ? ref : fieldId;
    }, [
        autoFocusOnMount,
        fieldIdMap,
        validationOptions,
        values
    ]);
    (0,useCompactSheetAutoFocus/* useCompactSheetAutoFocus */.v)(autoFocusFieldId, {
        enabled: autoFocusOnMount,
        scrollIntoView: Boolean(fieldIdMap)
    });
    (0,react.useEffect)(function() {
        var ref;
        if (!focusDropOnPickupSelect) {
            return;
        }
        var currentPickup = (ref = values.source) === null || ref === void 0 ? void 0 : ref.place_id;
        var hadPickup = prevPickupRef.current;
        if (!hadPickup && currentPickup) {
            if (skipProgrammaticDropFocusRef.current) {
                skipProgrammaticDropFocusRef.current = false;
            } else {
                focusField("quote-drop-city", {
                    delay: (0,homepageV2CompactSheet/* getQuoteFormPickupToDropFocusDelayMs */.FY)()
                });
            }
        }
        prevPickupRef.current = currentPickup;
    }, [
        focusDropOnPickupSelect,
        focusField,
        (ref2 = values.source) === null || ref2 === void 0 ? void 0 : ref2.place_id
    ]);
    var focusFirstInvalidField = (0,react.useCallback)(function() {
        var firstInvalidField = (0,validateQuoteForm/* getFirstQuoteFormInvalidFieldId */.KG)(values, validationOptions);
        if (firstInvalidField) {
            focusField(firstInvalidField);
        }
    }, [
        focusField,
        validationOptions,
        values
    ]);
    return {
        handleChange: handleChange,
        handleLocationInput: handleLocationInput,
        locationMessages: locationMessages,
        isFormValid: isFormValid,
        validationOptions: validationOptions,
        focusFirstInvalidField: focusFirstInvalidField
    };
}


/***/ }),

/***/ 81090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hp": function() { return /* binding */ getQuoteFormErrors; },
/* harmony export */   "KG": function() { return /* binding */ getFirstQuoteFormInvalidFieldId; },
/* harmony export */   "Kb": function() { return /* binding */ focusQuoteFormField; },
/* harmony export */   "N$": function() { return /* binding */ isQuoteFormValid; },
/* harmony export */   "WC": function() { return /* binding */ getRouteQuoteFormValidationOptions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _vahak_core_ui_dist_methods_keyboardViewport__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69849);
/* harmony import */ var _getQuoteFormCapacityError__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4121);
/* harmony import */ var _loadQuoteForm_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26107);




var QUOTE_FORM_FIELD_ORDER = [
    "quote-pickup-city",
    "quote-drop-city",
    "quote-tonnes"
];
function getQuoteFormErrors(values, options) {
    var ref, ref1;
    var errors = {};
    var ref2;
    var isRemoteConfigLoaded = (ref2 = options === null || options === void 0 ? void 0 : options.isRemoteConfigLoaded) !== null && ref2 !== void 0 ? ref2 : true;
    var ref3;
    var t = (ref3 = options === null || options === void 0 ? void 0 : options.t) !== null && ref3 !== void 0 ? ref3 : function(key) {
        return key;
    };
    var ref4;
    var skipCapacityValidation = (ref4 = options === null || options === void 0 ? void 0 : options.skipCapacityValidation) !== null && ref4 !== void 0 ? ref4 : false;
    if (!((ref = values.source) === null || ref === void 0 ? void 0 : ref.place_id)) {
        errors["quote-pickup-city"] = "Please select pickup city";
    }
    if (!((ref1 = values.destination) === null || ref1 === void 0 ? void 0 : ref1.place_id)) {
        errors["quote-drop-city"] = "Please select drop city";
    }
    if (!skipCapacityValidation) {
        var capacityError = (0,_getQuoteFormCapacityError__WEBPACK_IMPORTED_MODULE_1__/* .getQuoteFormCapacityError */ .w)(values.tonnes, isRemoteConfigLoaded, t);
        if (capacityError) {
            errors["quote-tonnes"] = capacityError;
        }
    }
    return errors;
}
function isQuoteFormValid(values, options) {
    return Object.keys(getQuoteFormErrors(values, options)).length === 0;
}
function getFirstQuoteFormInvalidFieldId(values, options) {
    var errors = getQuoteFormErrors(values, options);
    return QUOTE_FORM_FIELD_ORDER.find(function(fieldId) {
        return errors[fieldId];
    });
}
function getRouteQuoteFormValidationOptions(isRemoteConfigLoaded, t) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        isRemoteConfigLoaded: isRemoteConfigLoaded,
        t: t
    }, _loadQuoteForm_constants__WEBPACK_IMPORTED_MODULE_2__/* .ROUTE_QUOTE_SKIP_CAPACITY_VALIDATION */ .MC);
}
function resolveFocusQuoteFormFieldOptions(fieldIdMapOrOptions) {
    if (!fieldIdMapOrOptions) {
        return {};
    }
    var maybeFieldIdMap = fieldIdMapOrOptions;
    if ("quote-pickup-city" in maybeFieldIdMap || "quote-drop-city" in maybeFieldIdMap || "quote-tonnes" in maybeFieldIdMap) {
        var hasFocusOptions = "delay" in fieldIdMapOrOptions || "scrollIntoView" in fieldIdMapOrOptions || "clearance" in fieldIdMapOrOptions || "fieldIdMap" in fieldIdMapOrOptions;
        if (!hasFocusOptions) {
            return {
                fieldIdMap: maybeFieldIdMap
            };
        }
    }
    return fieldIdMapOrOptions;
}
function getQuoteFormFieldCandidateIds(fieldId, fieldIdMap) {
    var ref;
    var resolvedId = (ref = fieldIdMap === null || fieldIdMap === void 0 ? void 0 : fieldIdMap[fieldId]) !== null && ref !== void 0 ? ref : fieldId;
    return [
        resolvedId,
        "".concat(resolvedId, "__input"),
        "".concat(resolvedId, "__container")
    ];
}
function focusQuoteFormField(fieldId, fieldIdMapOrOptions) {
    var options = resolveFocusQuoteFormFieldOptions(fieldIdMapOrOptions);
    (0,_vahak_core_ui_dist_methods_keyboardViewport__WEBPACK_IMPORTED_MODULE_0__/* .focusFormControl */ .zy)({
        candidateIds: getQuoteFormFieldCandidateIds(fieldId, options.fieldIdMap),
        delay: options.delay,
        scrollIntoView: options.scrollIntoView,
        clearance: options.clearance
    });
}


/***/ }),

/***/ 30069:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"RouteDetailsStep_form__Dqmow","formFields":"RouteDetailsStep_formFields__Saxi4","fieldGroup":"RouteDetailsStep_fieldGroup__ZgEIi","fieldGroupPickup":"RouteDetailsStep_fieldGroupPickup__lqEKr","fieldGroupDrop":"RouteDetailsStep_fieldGroupDrop__ND7XM","label":"RouteDetailsStep_label__OSsTw","actions":"RouteDetailsStep_actions__OAUbb","cta":"RouteDetailsStep_cta__s7Dri","ctaIcon":"RouteDetailsStep_ctaIcon__pXV7w","disclaimer":"RouteDetailsStep_disclaimer__fs0xx"};

/***/ })

}]);